import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getTenantAccessAllChecks } from '../api/tenantAccessApi';
import { DataTable } from '../components/DataTable';
import { ErrorState } from '../components/ErrorState';
import { LoadingState } from '../components/LoadingState';
import { PageShell } from '../components/PageShell';

export function TenantAccessChecksPage() {
  const { t } = useTranslation(['tenantAccess', 'common']);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await getTenantAccessAllChecks({ per_page: 100 });
      setRows(response.data || []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const columns = useMemo(() => [
    { id: 'tenant_id', label: t('tenantAccess:checks.columns.tenant') },
    { id: 'result', label: t('tenantAccess:checks.columns.result') },
    { id: 'access_status', label: t('common:status') },
    { id: 'reason_code', label: t('tenantAccess:dashboard.columns.reason') },
    { id: 'context', label: t('tenantAccess:checks.columns.context') },
    { id: 'created_at', label: t('tenantAccess:checks.columns.checked_at') },
  ], [t]);

  if (loading) {
    return <LoadingState />;
  }

  if (error) {
    return <ErrorState message={t('tenantAccess:checks.load_failed')} onRetry={load} />;
  }

  return (
    <PageShell title={t('tenantAccess:checks.title')} subtitle={t('tenantAccess:checks.subtitle')}>
      <DataTable columns={columns} rows={rows} rowKey="id" emptyMessage={t('tenantAccess:checks.no_checks')} />
    </PageShell>
  );
}
